import './styles/integration-row.scss'

import React     from 'react'
import PropTypes from 'prop-types'

import { Form, Button } from 'semantic-ui-react'

import AsyncFilterDropdown from '../components/AsyncFilterDropdown'
import api from "../redux/api"


export default class IntegrationRow extends React.Component {
  static propTypes = {
    integration: PropTypes.object.isRequired,
    onChange:    PropTypes.func.isRequired,
    onAppend:    PropTypes.func.isRequired,
    onDelete:    PropTypes.func.isRequired,
  }

  handleSenderChange = (data) => {
    this.handlePropertyChange('sender', data)
  }

  handleReceiverChange = (data) => {
    this.handlePropertyChange('receiver', data)
  }

  handleDataTypeChange = (data) => {
    this.handlePropertyChange('dataType', data)
  }

  handlePropertyChange = (propName, data) => {
    this.props.onChange({ [propName]: data ? data.value : '' })
  }

  handleDelete = () => {
    this.props.onDelete(this.props.integration.id)
  }

  handleAppend = () => {
    this.props.onAppend(this.props.integration.id)
  }

  render() {
    const { sender, receiver, dataType } = this.props.integration

    return (
      <div className="integration-row">
        <div className="actions">
          <Button icon="delete" className="delete" onClick={this.handleDelete} />
          <Button icon="add" primary onClick={this.handleAppend} />
        </div>

        <Form.Field>
          <label>Sender</label>
          <AsyncFilterDropdown
            test={true}
            getOptionsByFilter={api.loadDataSystems}
            placeholder="Filter by Sender"
            onChange={this.handleSenderChange}
            value={sender}
          />
        </Form.Field>
        <Form.Field>
          <label>Receiver</label>
          <AsyncFilterDropdown
            test={true}
            getOptionsByFilter={api.loadDataSystems}
            placeholder="Filter by Receiver"
            onChange={this.handleReceiverChange}
            value={receiver}
          />
        </Form.Field>
        <Form.Field>
          <label>Data Type</label>
          <AsyncFilterDropdown
            test={true}
            getOptionsByFilter={api.loadDataTypes}
            placeholder="Filter by Data Types"
            onChange={this.handleDataTypeChange}
            value={dataType}
          />
        </Form.Field>
      </div>
    )
  }
}
